module.exports = __webpack_public_path__ + "img/male9.2384906d.jpg";